import { render } from "./SelectCancerReserve.vue?vue&type=template&id=b6c13f40"
import script from "./SelectCancerReserve.vue?vue&type=script&lang=js"
export * from "./SelectCancerReserve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__